var exports = {
  "xL": "ChannelIndexPage.module__voiceChannelContainer___bi1UaD",
  "jn": "ChannelIndexPage.module__voiceChannelFullscreenShell___bi1UaD",
  "Ku": "ChannelIndexPage.module__channelGrid___bi1UaD",
  "Uv": "ChannelIndexPage.module__channelGridVoiceCallActive___bi1UaD",
  "F5": "ChannelIndexPage.module__channelGridVoiceCallExpanded___bi1UaD",
  "hO": "ChannelIndexPage.module__voiceActiveHeaderWrapper___bi1UaD",
  "$A": "ChannelIndexPage.module__voiceActiveHeaderWrapperOverlay___bi1UaD",
  "QH": "ChannelIndexPage.module__voiceActiveHeaderWrapperExpanded___bi1UaD",
  "Hz": "ChannelIndexPage.module__compactCallWrapper___bi1UaD",
  "Gi": "ChannelIndexPage.module__compactCallWrapperExpanded___bi1UaD",
  "_p": "ChannelIndexPage.module__compactCallWrapperResizing___bi1UaD",
  "rF": "ChannelIndexPage.module__compactVoiceCallView___bi1UaD",
  "ac": "ChannelIndexPage.module__compactVoiceCallViewExpanded___bi1UaD",
  "wS": "ChannelIndexPage.module__contentGrid___bi1UaD",
  "cg": "ChannelIndexPage.module__chatAreaSlot___bi1UaD",
  "ec": "ChannelIndexPage.module__memberListDivider___bi1UaD",
  "ly": "ChannelIndexPage.module__searchPanel___bi1UaD",
  "hh": "ChannelIndexPage.module__voiceJoinEmptyState___bi1UaD",
  "HM": "ChannelIndexPage.module__voiceJoinEmptyContent___bi1UaD",
  "bo": "ChannelIndexPage.module__voiceJoinEmptyMark___bi1UaD",
  "NJ": "ChannelIndexPage.module__voiceJoinEmptyIcon___bi1UaD",
  "m2": "ChannelIndexPage.module__voiceJoinEmptyTitle___bi1UaD",
  "F0": "ChannelIndexPage.module__voiceJoinDisabledWrap___bi1UaD",
};

module.exports = exports;
